import { defineComponent, openBlock, createElementBlock, renderSlot, createElementVNode, normalizeClass, toDisplayString, createCommentVNode, resolveComponent, createBlock, mergeProps, withCtx, Fragment, renderList, createVNode, withModifiers } from 'vue';
import { rendererProps, useJsonFormsControl, useJsonFormsEnumControl, useJsonFormsOneOfEnumControl, DispatchRenderer, useJsonFormsLayout, useJsonFormsArrayControl, JsonForms } from '@jsonforms/vue';
import { useVanillaControl, useVanillaLayout, classes, useVanillaArrayControl, vanillaRenderers } from '@jsonforms/vue-vanilla';
import { isDescriptionHidden, composePaths, createDefaultValue, createAjv, rankWith, isBooleanControl, isDateControl, isDateTimeControl, isEnumControl, isOneOfEnumControl, isIntegerControl, and, isStringControl, isMultiLineControl, isNumberControl, isTimeControl, schemaTypeIs, isLayout, uiTypeIs } from '@jsonforms/core';
import * as Sentry from '@sentry/browser';
import { Collapse, Popover } from 'bootstrap';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var script$k = defineComponent({
  name: 'custom-control-wrapper-checkbox',
  props: {
    id: {
      required: true,
      type: String
    },
    description: {
      required: false,
      type: String,
      default: undefined
    },
    errors: {
      required: false,
      type: String,
      default: undefined
    },
    label: {
      required: false,
      type: String,
      default: undefined
    },
    appliedOptions: {
      required: false,
      type: Object,
      default: undefined
    },
    visible: {
      required: false,
      type: Boolean,
      default: true
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    isFocused: {
      required: false,
      type: Boolean,
      default: false
    },
    styles: {
      required: true,
      type: Object
    }
  },
  computed: {
    showDescription: function showDescription() {
      if (this.description) {
        var _this$appliedOptions;

        return !isDescriptionHidden(this.visible, this.description, this.isFocused, !!((_this$appliedOptions = this.appliedOptions) !== null && _this$appliedOptions !== void 0 && _this$appliedOptions.showUnfocusedDescription));
      }

      return false;
    }
  }
});

var _hoisted_1$f = ["id"];
var _hoisted_2$6 = ["for"];
function render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.visible ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "form-check mb-3",
    id: _ctx.id
  }, [renderSlot(_ctx.$slots, "default"), createElementVNode("label", {
    for: _ctx.id + '-input',
    class: normalizeClass(["form-check-label", {
      'is-required': _ctx.required
    }])
  }, toDisplayString(_ctx.label), 11, _hoisted_2$6), _ctx.showDescription ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.styles.control.description)
  }, toDisplayString(_ctx.description), 3)) : createCommentVNode("", true), _ctx.errors ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(_ctx.styles.control.error)
  }, toDisplayString(_ctx.errors), 3)) : createCommentVNode("", true)], 8, _hoisted_1$f)) : createCommentVNode("", true);
}

script$k.render = render$k;

var controlRenderer$2 = defineComponent({
  name: 'custom-boolean-control-renderer',
  components: {
    CustomControlWrapperCheckbox: script$k
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props), function (target) {
      return target.checked;
    });
  }
});
var script$j = controlRenderer$2;

var _hoisted_1$e = ["id", "checked", "disabled", "placeholder"];
function render$j(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper_checkbox = resolveComponent("custom-control-wrapper-checkbox");

  return openBlock(), createBlock(_component_custom_control_wrapper_checkbox, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        type: "checkbox",
        class: normalizeClass('form-check-input' + (!!_ctx.control.errors ? ' is-invalid' : '')),
        id: _ctx.control.id + '-input',
        checked: !!_ctx.control.data,
        disabled: !_ctx.control.enabled,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$e)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$j.render = render$j;

var script$i = defineComponent({
  name: 'custom-control-wrapper',
  props: {
    id: {
      required: true,
      type: String
    },
    description: {
      required: false,
      type: String,
      default: undefined
    },
    errors: {
      required: false,
      type: String,
      default: undefined
    },
    label: {
      required: false,
      type: String,
      default: undefined
    },
    appliedOptions: {
      required: false,
      type: Object,
      default: undefined
    },
    visible: {
      required: false,
      type: Boolean,
      default: true
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    isFocused: {
      required: false,
      type: Boolean,
      default: false
    },
    styles: {
      required: true,
      type: Object
    }
  },
  computed: {
    showDescription: function showDescription() {
      if (this.description) {
        var _this$appliedOptions;

        return !isDescriptionHidden(this.visible, this.description, this.isFocused, !!((_this$appliedOptions = this.appliedOptions) !== null && _this$appliedOptions !== void 0 && _this$appliedOptions.showUnfocusedDescription));
      }

      return false;
    }
  }
});

var _hoisted_1$d = ["id"];
var _hoisted_2$5 = ["for"];
function render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.visible ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.styles.control.root + ' mb-3'),
    id: _ctx.id
  }, [createElementVNode("label", {
    for: _ctx.id + '-input',
    class: normalizeClass([_ctx.styles.control.label, {
      'is-required': _ctx.required
    }])
  }, toDisplayString(_ctx.label), 11, _hoisted_2$5), _ctx.showDescription ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.styles.control.description)
  }, toDisplayString(_ctx.description), 3)) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default"), _ctx.errors ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(_ctx.styles.control.error)
  }, toDisplayString(_ctx.errors), 3)) : createCommentVNode("", true)], 10, _hoisted_1$d)) : createCommentVNode("", true);
}

script$i.render = render$i;

var customDateRenderer = defineComponent({
  name: 'date-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props));
  }
});
var script$h = customDateRenderer;

var _hoisted_1$c = ["id", "value", "disabled", "autofocus", "placeholder"];
function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        type: "date",
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.input + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$c)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$h.render = render$h;

var toISOString = function toISOString(inputDateTime) {
  return inputDateTime === '' ? '' : inputDateTime + ':00.000Z';
};

var dateTimeControlRenderer = defineComponent({
  name: 'datetime-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props), function (target) {
      return toISOString(target.value);
    });
  },
  computed: {
    dataTime: function dataTime() {
      var _this$control$data;

      return ((_this$control$data = this.control.data) !== null && _this$control$data !== void 0 ? _this$control$data : '').substr(0, 16);
    }
  }
});
var script$g = dateTimeControlRenderer;

var _hoisted_1$b = ["id", "value", "disabled", "autofocus", "placeholder"];
function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        type: "datetime-local",
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.input + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.dataTime,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$b)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$g.render = render$g;

var labels = {
  emptyOptionlabel: 'Bitte wählen ...'
};

var controlRenderer$1 = defineComponent({
  name: 'enum-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsEnumControl(props));
  },
  data: function data() {
    return {
      emptyOptionlabel: labels.emptyOptionlabel
    };
  }
});
var script$f = controlRenderer$1;

var _hoisted_1$a = ["id", "value", "disabled", "autofocus"];
var _hoisted_2$4 = ["value", "label"];
function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;

  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("select", {
        id: _ctx.control.id + '-select',
        class: normalizeClass(_ctx.styles.control.select + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, [!_ctx.control.data ? (openBlock(), createElementBlock("option", {
        value: "",
        key: "empty",
        class: normalizeClass(_ctx.styles.control.option)
      }, toDisplayString(_this.emptyOptionlabel), 3)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.control.options, function (optionElement) {
        return openBlock(), createElementBlock("option", {
          key: optionElement.value,
          value: optionElement.value,
          label: optionElement.label,
          class: normalizeClass(_ctx.styles.control.option)
        }, toDisplayString(optionElement.label), 11, _hoisted_2$4);
      }), 128))], 42, _hoisted_1$a)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$f.render = render$f;

var customEnumOneOfControlRenderer = defineComponent({
  name: 'enum-oneof-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsOneOfEnumControl(props));
  },
  data: function data() {
    return {
      emptyOptionlabel: labels.emptyOptionlabel
    };
  }
});
var script$e = customEnumOneOfControlRenderer;

var _hoisted_1$9 = ["id", "value", "disabled", "autofocus"];
var _hoisted_2$3 = ["value", "label"];
function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;

  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("select", {
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.select + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, [createElementVNode("option", {
        value: "",
        key: "empty",
        class: normalizeClass(_ctx.styles.control.option)
      }, toDisplayString(_this.emptyOptionlabel), 3), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.control.options, function (optionElement) {
        return openBlock(), createElementBlock("option", {
          key: optionElement.value,
          value: optionElement.value,
          label: optionElement.label,
          class: normalizeClass(_ctx.styles.control.option)
        }, null, 10, _hoisted_2$3);
      }), 128))], 42, _hoisted_1$9)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$e.render = render$e;

var layoutRenderer$1 = defineComponent({
  name: 'group-renderer',
  components: {
    DispatchRenderer: DispatchRenderer
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaLayout(useJsonFormsLayout(props));
  }
});
var script$d = layoutRenderer$1;

var _hoisted_1$8 = {
  class: "d-flex align-items-end group-heading"
};
var _hoisted_2$2 = {
  class: "group-title"
};
var _hoisted_3$1 = ["data-bs-content"];
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_dispatch_renderer = resolveComponent("dispatch-renderer");

  return _ctx.layout.visible ? (openBlock(), createElementBlock("fieldset", {
    key: 0,
    class: normalizeClass(_ctx.styles.group.root)
  }, [createElementVNode("div", _hoisted_1$8, [createElementVNode("div", _hoisted_2$2, [_ctx.layout.uischema.label ? (openBlock(), createElementBlock("legend", {
    key: 0,
    class: normalizeClass(_ctx.styles.group.label)
  }, toDisplayString(_ctx.layout.uischema.label), 3)) : createCommentVNode("", true), _ctx.layout.uischema.description ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(_ctx.styles.group.description + ' mb-3')
  }, toDisplayString(_ctx.layout.uischema.description), 3)) : createCommentVNode("", true)]), _ctx.layout.uischema.descriptionHelp ? (openBlock(), createElementBlock("span", {
    key: 0,
    "data-bs-trigger": "hover",
    "data-bs-toggle": "popover",
    "data-bs-placement": "top",
    "data-bs-content": _ctx.layout.uischema.descriptionHelp,
    class: "js-description-help mb-3 ms-2"
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.styles.group.descriptionHelpButton),
    disabled: "",
    role: "button",
    tabindex: "0"
  }, "?", 2)], 8, _hoisted_3$1)) : createCommentVNode("", true)]), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.layout.uischema.elements, function (element, index) {
    return openBlock(), createElementBlock("div", {
      key: "".concat(_ctx.layout.path, "-").concat(index),
      class: normalizeClass(_ctx.styles.group.item)
    }, [createVNode(_component_dispatch_renderer, {
      schema: _ctx.layout.schema,
      uischema: element,
      path: _ctx.layout.path,
      enabled: _ctx.layout.enabled,
      renderers: _ctx.layout.renderers,
      cells: _ctx.layout.cells
    }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"])], 2);
  }), 128))], 2)) : createCommentVNode("", true);
}

script$d.render = render$d;

var customIntegerControlRenderer = defineComponent({
  name: 'integer-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props), function (target) {
      var valueAsInt = parseInt(target.value, 10);

      if (isNaN(valueAsInt)) {
        valueAsInt = 0;
      }

      return valueAsInt;
    });
  }
});
var script$c = customIntegerControlRenderer;

var _hoisted_1$7 = ["id", "value", "disabled", "autofocus", "placeholder"];
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        type: "number",
        step: 1,
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.input + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$7)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$c.render = render$c;

var customMultiStringControlRenderer = defineComponent({
  name: 'multi-string-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props));
  }
});
var script$b = customMultiStringControlRenderer;

var _hoisted_1$6 = ["id", "value", "disabled", "autofocus", "placeholder"];
function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("textarea", {
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.textarea + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        rows: "6",
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$6)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$b.render = render$b;

var customNumberControlRenderer = defineComponent({
  name: 'number-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props), function (target) {
      return Number(target.value);
    });
  },
  computed: {
    step: function step() {
      var _this$appliedOptions$;

      return (_this$appliedOptions$ = this.appliedOptions.step) !== null && _this$appliedOptions$ !== void 0 ? _this$appliedOptions$ : 0.1;
    }
  }
});
var script$a = customNumberControlRenderer;

var _hoisted_1$5 = ["step", "id", "value", "disabled", "autofocus", "placeholder"];
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        type: "number",
        step: _ctx.step,
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.input + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$5)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$a.render = render$a;

var customStringControlRenderer = defineComponent({
  name: 'string-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props));
  }
});
var script$9 = customStringControlRenderer;

var _hoisted_1$4 = ["id", "value", "disabled", "autofocus", "placeholder"];
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.input + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$4)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$9.render = render$9;

var customTimeControlRenderer = defineComponent({
  name: 'time-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props));
  }
});
var script$8 = customTimeControlRenderer;

var _hoisted_1$3 = ["id", "value", "disabled", "autofocus", "placeholder"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("input", {
        type: "time",
        id: _ctx.control.id + '-input',
        class: normalizeClass(_ctx.styles.control.input + (!!_ctx.control.errors ? ' is-invalid' : '')),
        value: _ctx.control.data,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        onChange: _cache[0] || (_cache[0] = function () {
          return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
        }),
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.isFocused = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.isFocused = false;
        })
      }, null, 42, _hoisted_1$3)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$8.render = render$8;

var customUnknownRenderer = defineComponent({
  name: 'customUnknownRenderer',
  created: function created() {
    Sentry.setExtras(this.control);
    Sentry.captureMessage('UI-Schema-definition found no applicable renderer (see in extras the uischema)');
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props));
  }
});
var script$7 = customUnknownRenderer;

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div");
}

script$7.render = render$7;

var _templateObject, _templateObject2;
var listItem = defineComponent({
  name: 'custom-array-list-element',
  props: {
    initiallyExpanded: {
      required: false,
      type: Boolean,
      default: false
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    moveUpEnabled: {
      required: false,
      type: Boolean,
      default: true
    },
    moveDownEnabled: {
      required: false,
      type: Boolean,
      default: true
    },
    moveUp: {
      required: false,
      type: Function,
      default: undefined
    },
    moveDown: {
      required: false,
      type: Function,
      default: undefined
    },
    delete: {
      required: false,
      type: Function,
      default: undefined
    },
    styles: {
      required: true,
      type: Object
    },
    deleteLabel: {
      type: String,
      default: 'Entfernen'
    }
  },
  data: function data() {
    return {
      expanded: this.initiallyExpanded
    };
  },
  computed: {
    contentClasses: function contentClasses() {
      return classes(_templateObject || (_templateObject = _taggedTemplateLiteral(["", " ", ""])), this.styles.arrayList.itemContent, this.expanded && this.styles.arrayList.itemExpanded);
    },
    toolbarClasses: function toolbarClasses() {
      return classes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", " ", ""])), this.styles.arrayList.itemToolbar, this.expanded && this.styles.arrayList.itemExpanded);
    }
  },
  methods: {
    expandClicked: function expandClicked() {
      this.expanded = !this.expanded;
    },
    moveUpClicked: function moveUpClicked(event) {
      var _this$moveUp;

      event.stopPropagation(); // eslint-disable-next-line no-unused-expressions

      (_this$moveUp = this.moveUp) === null || _this$moveUp === void 0 ? void 0 : _this$moveUp.call(this);
    },
    moveDownClicked: function moveDownClicked(event) {
      var _this$moveDown;

      event.stopPropagation(); // eslint-disable-next-line no-unused-expressions

      (_this$moveDown = this.moveDown) === null || _this$moveDown === void 0 ? void 0 : _this$moveDown.call(this);
    },
    deleteClicked: function deleteClicked(event) {
      var _this$delete;

      event.stopPropagation(); // eslint-disable-next-line no-unused-expressions

      (_this$delete = this.delete) === null || _this$delete === void 0 ? void 0 : _this$delete.call(this);
    }
  }
});
var script$6 = listItem;

var _hoisted_1$2 = ["disabled"];
var _hoisted_2$1 = ["disabled"];
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.styles.arrayList.item)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.contentClasses)
  }, [renderSlot(_ctx.$slots, "default")], 2), createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.expandClicked && _ctx.expandClicked.apply(_ctx, arguments);
    }),
    class: normalizeClass(_ctx.toolbarClasses)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.styles.arrayList.itemLabel)
  }, toDisplayString(_ctx.label), 3), createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.moveUpClicked && _ctx.moveUpClicked.apply(_ctx, arguments);
    }),
    disabled: !_ctx.moveUpEnabled,
    class: normalizeClass(_ctx.styles.arrayList.itemMoveUp),
    type: "button"
  }, " ↑ ", 10, _hoisted_1$2), createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.moveDownClicked && _ctx.moveDownClicked.apply(_ctx, arguments);
    }),
    disabled: !_ctx.moveDownEnabled,
    class: normalizeClass(_ctx.styles.arrayList.itemMoveDown),
    type: "button"
  }, " ↓ ", 10, _hoisted_2$1), createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.deleteClicked && _ctx.deleteClicked.apply(_ctx, arguments);
    }),
    class: normalizeClass(_ctx.styles.arrayList.itemDelete),
    type: "button"
  }, toDisplayString(_ctx.deleteLabel), 3)], 2)], 2);
}

script$6.render = render$6;

var controlRenderer = defineComponent({
  name: 'array-list-renderer',
  components: {
    CustomArrayListElement: script$6,
    DispatchRenderer: DispatchRenderer
  },
  props: _objectSpread2(_objectSpread2({}, rendererProps()), {}, {
    addButtonLabel: {
      type: String,
      default: 'Hinzufügen'
    }
  }),
  setup: function setup(props) {
    return useVanillaArrayControl(useJsonFormsArrayControl(props));
  },
  computed: {
    noData: function noData() {
      return !this.control.data || this.control.data.length === 0;
    }
  },
  methods: {
    composePaths: composePaths,
    createDefaultValue: createDefaultValue,
    addButtonClick: function addButtonClick() {
      this.addItem(this.control.path, createDefaultValue(this.control.schema))();
    }
  }
});
var script$5 = controlRenderer;

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_dispatch_renderer = resolveComponent("dispatch-renderer");

  var _component_custom_array_list_element = resolveComponent("custom-array-list-element");

  return _ctx.control.visible ? (openBlock(), createElementBlock("fieldset", {
    key: 0,
    class: normalizeClass(_ctx.styles.arrayList.root)
  }, [createElementVNode("legend", {
    class: normalizeClass(_ctx.styles.arrayList.legend)
  }, [createElementVNode("label", {
    class: normalizeClass(_ctx.styles.arrayList.label)
  }, toDisplayString(_ctx.control.label), 3), createElementVNode("button", {
    class: normalizeClass(_ctx.styles.arrayList.addButton),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.addButtonClick && _ctx.addButtonClick.apply(_ctx, arguments);
    }),
    type: "button"
  }, toDisplayString(_ctx.addButtonLabel), 3)], 2), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.control.data, function (element, index) {
    return openBlock(), createElementBlock("div", {
      key: "".concat(_ctx.control.path, "-").concat(index),
      class: normalizeClass(_ctx.styles.arrayList.itemWrapper)
    }, [createVNode(_component_custom_array_list_element, {
      moveUp: _ctx.moveUp(_ctx.control.path, index),
      moveUpEnabled: index > 0,
      moveDown: _ctx.moveDown(_ctx.control.path, index),
      moveDownEnabled: index < _ctx.control.data.length - 1,
      delete: _ctx.removeItems(_ctx.control.path, [index]),
      label: _ctx.childLabelForIndex(index),
      styles: _ctx.styles
    }, {
      default: withCtx(function () {
        return [createVNode(_component_dispatch_renderer, {
          schema: _ctx.control.schema,
          uischema: _ctx.childUiSchema,
          path: _ctx.composePaths(_ctx.control.path, "".concat(index)),
          enabled: _ctx.control.enabled,
          renderers: _ctx.control.renderers,
          cells: _ctx.control.cells
        }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"])];
      }),
      _: 2
    }, 1032, ["moveUp", "moveUpEnabled", "moveDown", "moveDownEnabled", "delete", "label", "styles"])], 2);
  }), 128)), _ctx.noData ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.styles.arrayList.noData)
  }, " No data ", 2)) : createCommentVNode("", true)], 2)) : createCommentVNode("", true);
}

script$5.render = render$5;

var layoutRenderer = defineComponent({
  name: 'extendable-group-renderer',
  components: {
    DispatchRenderer: DispatchRenderer
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaLayout(useJsonFormsLayout(props));
  },
  created: function created() {
    // to make sure all errors are visible to the user, we need to expand all the collapse elements
    // this is achieved by adding a Event to the checking of the Form (in the FormRenderComponent)
    // and adding the following event listener which shows all not shown collapse elements
    window.addEventListener('formCheckedWithErrors', function () {
      // it would be possible to narrow it down to the exact collapse which needs to open, but this needs a few
      // adjustments defined in the corresponding Issue descript/vue-js-json-forms-bootstrap-renderer#9
      var collapseElementList = [].slice.call(document.querySelectorAll('.collapse:not(.show)'));
      collapseElementList.map(function (collapseEl) {
        new Collapse(collapseEl).show();
      });
    });
  },
  methods: {
    hashUI: function hashUI(uiJSON) {
      /*
      the hashing is basically enough here, as we don't need a eloquent way of generating hashes, but just unique
      ones to only trigger the right collapse divs when triggering them by buttons.
             code based on:
      https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
       */
      var uiString = JSON.stringify(uiJSON);
      var hash = 0;
      if (uiString.length === 0) return hash;
      var char;

      for (var i = 0; i < uiString.length; i++) {
        char = uiString.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
      }

      return hash;
    }
  }
});
var script$4 = layoutRenderer;

var _hoisted_1$1 = ["data-bs-target"];
var _hoisted_2 = ["id"];
var _hoisted_3 = {
  class: "d-flex justify-content-between align-items-start"
};
var _hoisted_4 = ["data-bs-content"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_dispatch_renderer = resolveComponent("dispatch-renderer");

  return _ctx.layout.visible ? (openBlock(), createElementBlock("fieldset", {
    key: 0,
    class: normalizeClass(_ctx.styles.extendableGroup.root)
  }, [createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": '#id' + _ctx.hashUI(_ctx.layout.uischema),
    "aria-expanded": "false",
    "aria-controls": "collapse-action-description"
  }, [_ctx.layout.uischema.label ? (openBlock(), createElementBlock("legend", {
    key: 0,
    class: normalizeClass(_ctx.styles.extendableGroup.label)
  }, toDisplayString(_ctx.layout.uischema.label), 3)) : createCommentVNode("", true)], 8, _hoisted_1$1), createElementVNode("div", {
    class: "collapse",
    id: 'id' + _ctx.hashUI(_ctx.layout.uischema)
  }, [createElementVNode("div", _hoisted_3, [_ctx.layout.uischema.description ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.styles.extendableGroup.description + ' mb-3')
  }, toDisplayString(_ctx.layout.uischema.description), 3)) : createCommentVNode("", true), _ctx.layout.uischema.descriptionHelp ? (openBlock(), createElementBlock("span", {
    key: 1,
    "data-bs-trigger": "hover",
    "data-bs-toggle": "popover",
    "data-bs-placement": "top",
    "data-bs-content": _ctx.layout.uischema.descriptionHelp,
    class: "js-description-help"
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.styles.extendableGroup.descriptionHelpButton),
    disabled: "",
    role: "button",
    tabindex: "0"
  }, "?", 2)], 8, _hoisted_4)) : createCommentVNode("", true)]), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.layout.uischema.elements, function (element, index) {
    return openBlock(), createElementBlock("div", {
      key: "".concat(_ctx.layout.path, "-").concat(index),
      class: normalizeClass(_ctx.styles.extendableGroup.item)
    }, [createVNode(_component_dispatch_renderer, {
      schema: _ctx.layout.schema,
      uischema: element,
      path: _ctx.layout.path,
      enabled: _ctx.layout.enabled,
      renderers: _ctx.layout.renderers,
      cells: _ctx.layout.cells
    }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"])], 2);
  }), 128))], 8, _hoisted_2)], 2)) : createCommentVNode("", true);
}

script$4.render = render$4;

var styles$1 = {
  control: {
    root: 'control',
    label: 'label form-label',
    description: 'description form-text',
    input: 'input form-control',
    // 'text-danger' should be 'invalid-feedback' but for some reason invalid feedback in the form is
    // rendered as 'display: none;'. To still have easily visible errors 'text-danger' is added
    error: 'error text-danger',
    textarea: 'text-area form-control',
    select: 'select form-select',
    option: 'option'
  },
  verticalLayout: {
    root: 'vertical-layout',
    item: 'vertical-layout-item'
  },
  horizontalLayout: {
    root: 'horizontal-layout row',
    item: 'horizontal-layout-item col-6'
  },
  group: {
    root: 'group',
    label: 'group-label',
    item: 'group-item',
    description: 'text-muted',
    descriptionHelpButton: 'badge bg-secondary rounded-pill'
  },
  extendableGroup: {
    root: 'group',
    label: 'group-label',
    item: 'group-item',
    description: 'text-muted',
    descriptionHelpButton: 'badge bg-secondary rounded-pill'
  },
  arrayList: {
    root: 'array-list',
    legend: 'array-list-legend',
    addButton: 'array-list-add btn btn-sm btn-link',
    label: 'array-list-label',
    itemWrapper: 'array-list-item-wrapper',
    noData: 'array-list-no-data d-none',
    item: 'array-list-item',
    itemToolbar: 'array-list-item-toolbar',
    itemLabel: 'array-list-item-label d-none',
    itemContent: 'array-list-item-content',
    itemExpanded: 'expanded',
    itemMoveUp: 'array-list-item-move-up btn btn-sm',
    itemMoveDown: 'array-list-item-move-down btn btn-sm',
    itemDelete: 'array-list-item-delete btn btn-sm btn-link'
  },
  label: {
    root: 'label-element'
  }
};

var alwaysMatchTester$1 = function alwaysMatchTester() {
  // this tester is used to catch exceptions. it will always match everything and needs to be ranked with 0 as
  // the JSONForms UnknownRenderer matches with -1 and every normal renderer matches with a value >=1
  return true;
}; // every renderer here is ranked with an integer one higher than the vue-vanilla renderers of JSONForms


var renderers$1 = [{
  tester: rankWith(2, isBooleanControl),
  renderer: script$j
}, {
  tester: rankWith(3, isDateControl),
  renderer: script$h
}, {
  tester: rankWith(3, isDateTimeControl),
  renderer: script$g
}, {
  tester: rankWith(3, isEnumControl),
  renderer: script$f
}, {
  tester: rankWith(3, isOneOfEnumControl),
  renderer: script$e
}, {
  tester: rankWith(2, isIntegerControl),
  renderer: script$c
}, {
  tester: rankWith(3, and(isStringControl, isMultiLineControl)),
  renderer: script$b
}, {
  tester: rankWith(2, isNumberControl),
  renderer: script$a
}, {
  tester: rankWith(2, isStringControl),
  renderer: script$9
}, {
  tester: rankWith(3, isTimeControl),
  renderer: script$8
}, {
  tester: rankWith(0, alwaysMatchTester$1),
  renderer: script$7
}, {
  tester: rankWith(3, schemaTypeIs('array')),
  renderer: script$5
}, {
  renderer: script$d,
  tester: rankWith(3, and(isLayout, uiTypeIs('Group')))
}, {
  renderer: script$4,
  tester: rankWith(3, and(isLayout, uiTypeIs('ExtendableGroup')))
}].concat(_toConsumableArray(vanillaRenderers));

function generateCustomErrorMessages() {
  var out = ' ';
  out += 'if (vErrors) {vErrors = vErrors.map((v) => {';
  out += 'if (v.keyword === \'required\') {v.message = \'Bitte füllen Sie dieses Feld aus.\';} '; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'minLength\') {v.message = `Bitte füllen Sie dieses Feld aus.`;} '; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'maxLength\') {v.message = `Bitte geben Sie einen Wert ein, der nicht länger als ${v.params?.limit} Zeichen ist.`;} '; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'maximum\') {v.message = `Bitte geben Sie einen Wert ein, der kleiner oder gleich ${v.params?.limit} ist.`;} '; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'minimum\') {v.message = `Bitte geben Sie einen Wert ein, der größer oder gleich ${v.params?.limit} ist.`;}'; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'enum\') {v.message = `Bitte wählen Sie eine Option.`;}'; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'type\' && v.params && v.params.type == \'integer\') {v.message = `Bitte geben Sie eine Zahl ein.`;}'; // eslint-disable-next-line no-template-curly-in-string

  out += 'else if (v.keyword === \'type\' && v.params && v.params.type == \'number\') {v.message = `Bitte geben Sie eine Zahl ein.`;}'; // eslint-disable-next-line no-template-curly-in-string

  out += 'return v;})};';
  return out;
}

var script$3 = defineComponent({
  name: 'FormRenderComponent',
  components: {
    JsonForms: JsonForms
  },
  props: {
    formObject: {
      type: Object,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    emptyOptionlabel: {
      type: String,
      default: 'Bitte wählen ...'
    }
  },
  data: function data() {
    /*
    To localize and customize the JSONForms error messages they suggest the library 'ajv-errors'
    We got it working but only under the caveat, that it was only possible to generate 1 error Message
    regardless of the error type for each field. Additionally every field had to be added, which needed a validation.
         This wasn't expected but it seems that ajv-error doesn't work as expected for nested definitions or the JSONForms
    interaction at this point with it prohibits this somehow.
         The function `generateCustomErrorMessages` handles the replacement of the error messages generated by the ajv
    instance from JSONforms. We will add a new keyword to the ajv instance which looks for 'customErrorMessages' and
    if it is set the replacement takes place.
    */
    labels.emptyOptionlabel = this.emptyOptionlabel;
    var customizedAjvInstance = createAjv().addKeyword('customErrorMessages', {
      inline: generateCustomErrorMessages,
      statements: true,
      valid: true,
      errors: 'full'
    });
    return {
      renderers: Object.freeze(renderers$1),
      givenForm: this.formObject,
      data: JSON,
      formScheme: JSON,
      uiScheme: JSON,
      ajv: customizedAjvInstance,
      hasErrors: true,
      errors: [],
      validationMode: 'ValidateAndHide'
    };
  },
  methods: {
    switchToValidateAndShow: function switchToValidateAndShow() {
      this.validationMode = 'ValidateAndShow';

      if (this.errors && this.errors.length > 0) {
        window.dispatchEvent(new Event('formCheckedWithErrors'));
      }
    },
    onChange: function onChange(event) {
      this.data = event.data;
      this.givenForm.answers = event.data;
      this.hasErrors = !(event.errors && event.errors.length === 0);
      this.errors = event.errors;

      if (this.data) {
        this.$emit('changed', event.data);
      }
    },
    onSubmit: function onSubmit() {
      this.$emit('submitted', this.givenForm.answers);
    }
  },
  mounted: function mounted() {
    // the functionality to initialize the popovers is done here instead of the component where one is set
    // because we of the nextTick call. The selector for the initialization is the class js-description-help
    // for every popover and all of them are become present in the DOM at the same time, so if it would lie inside
    // of the group component it would trigger the initialization a bit to often. Unfortunately the group lvl of the
    // JSONForm ui descriptions doesn't have a property which could be used to give an unique id, so the initialization
    // happens here.
    this.$nextTick(function () {
      var popoverElementList = [].slice.call(document.querySelectorAll('.js-description-help'));
      popoverElementList.map(function (popoverEl) {
        if (!Popover.getInstance(popoverEl)) {
          return new Popover(popoverEl, {
            container: 'body',
            trigger: 'hover',
            placement: 'top'
          });
        }
      });
    });
  },
  emits: ['submitted', 'changed'],
  provide: function provide() {
    return {
      styles: styles$1
    };
  }
});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_json_forms = resolveComponent("json-forms");

  return openBlock(), createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = withModifiers(function () {
      return _ctx.onSubmit && _ctx.onSubmit.apply(_ctx, arguments);
    }, ["prevent"]))
  }, [createVNode(_component_json_forms, {
    data: _ctx.givenForm.answers,
    renderers: _ctx.renderers,
    schema: _ctx.givenForm.form_schema,
    uischema: _ctx.givenForm.form_ui_schema,
    readonly: _ctx.isReadOnly,
    ajv: _ctx.ajv,
    validationMode: _ctx.validationMode,
    onChange: _ctx.onChange
  }, null, 8, ["data", "renderers", "schema", "uischema", "readonly", "ajv", "validationMode", "onChange"]), renderSlot(_ctx.$slots, "default")], 32);
}

script$3.render = render$3;

var printLayoutRenderer = defineComponent({
  name: 'print-group-renderer',
  components: {
    DispatchRenderer: DispatchRenderer
  },
  props: _objectSpread2({}, rendererProps()),
  setup: function setup(props) {
    return useVanillaLayout(useJsonFormsLayout(props));
  }
});
var script$2 = printLayoutRenderer;

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_dispatch_renderer = resolveComponent("dispatch-renderer");

  return _ctx.layout.visible ? (openBlock(), createElementBlock("fieldset", {
    key: 0,
    class: normalizeClass(_ctx.styles.group.root)
  }, [_ctx.layout.uischema.label ? (openBlock(), createElementBlock("legend", {
    key: 0,
    class: normalizeClass(_ctx.styles.group.label)
  }, toDisplayString(_ctx.layout.uischema.label), 3)) : createCommentVNode("", true), _ctx.layout.uischema.description ? (openBlock(), createElementBlock("span", {
    key: 1,
    class: normalizeClass(_ctx.styles.group.description + ' d-inline-block mb-3')
  }, toDisplayString(_ctx.layout.uischema.description), 3)) : createCommentVNode("", true), _ctx.layout.uischema.descriptionHelp ? (openBlock(), createElementBlock("span", {
    key: 2,
    class: normalizeClass(_ctx.styles.group.description + ' d-inline-block mb-3')
  }, " (" + toDisplayString(_ctx.layout.uischema.descriptionHelp) + ") ", 3)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.layout.uischema.elements, function (element, index) {
    return openBlock(), createElementBlock("div", {
      key: "".concat(_ctx.layout.path, "-").concat(index),
      class: normalizeClass(_ctx.styles.group.item)
    }, [createVNode(_component_dispatch_renderer, {
      schema: _ctx.layout.schema,
      uischema: element,
      path: _ctx.layout.path,
      enabled: _ctx.layout.enabled,
      renderers: _ctx.layout.renderers,
      cells: _ctx.layout.cells
    }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"])], 2);
  }), 128))], 2)) : createCommentVNode("", true);
}

script$2.render = render$2;

var printMultiStringControlRenderer = defineComponent({
  name: 'print-multi-string-control-renderer',
  components: {
    CustomControlWrapper: script$i
  },
  props: _objectSpread2({}, rendererProps()),
  computed: {
    controlData: function controlData() {
      return this.control.data ? this.control.data.replace(/\n/g, '<br>') : '';
    }
  },
  setup: function setup(props) {
    return useVanillaControl(useJsonFormsControl(props));
  }
});
var script$1 = printMultiStringControlRenderer;

var _hoisted_1 = ["innerHTML"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_custom_control_wrapper = resolveComponent("custom-control-wrapper");

  return openBlock(), createBlock(_component_custom_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(function () {
      return [createElementVNode("div", {
        class: normalizeClass(_ctx.styles.control.textarea + ' border p-4')
      }, [createElementVNode("span", {
        innerHTML: _ctx.controlData
      }, null, 8, _hoisted_1)], 2)];
    }),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}

script$1.render = render$1;

var styles = {
  control: {
    root: 'control d-print-block',
    label: 'label form-label',
    description: 'description form-text',
    input: 'input form-control',
    // 'text-danger' should be 'invalid-feedback' but for some reason invalid feedback in the form is
    // rendered as 'display: none;'. To still have easily visible errors 'text-danger' is added
    error: 'error text-danger',
    textarea: 'text-area',
    select: 'select form-select',
    option: 'option'
  },
  verticalLayout: {
    root: 'vertical-layout',
    item: 'vertical-layout-item'
  },
  horizontalLayout: {
    root: 'horizontal-layout row',
    item: 'horizontal-layout-item col-6'
  },
  group: {
    root: 'group',
    label: 'group-label',
    item: 'group-item',
    description: 'text-muted',
    descriptionHelpButton: 'badge bg-secondary rounded-pill'
  },
  arrayList: {
    root: 'array-list',
    legend: 'array-list-legend',
    addButton: 'array-list-add d-none',
    label: 'array-list-label',
    itemWrapper: 'array-list-item-wrapper',
    noData: 'array-list-no-data d-none',
    item: 'array-list-item',
    itemToolbar: 'array-list-item-toolbar',
    itemLabel: 'array-list-item-label d-none',
    itemContent: 'array-list-item-content',
    itemExpanded: 'expanded',
    itemMoveUp: 'array-list-item-move-up d-none',
    itemMoveDown: 'array-list-item-move-down d-none',
    itemDelete: 'array-list-item-delete d-none'
  },
  label: {
    root: 'label-element'
  }
};

var alwaysMatchTester = function alwaysMatchTester() {
  // this tester is used to catch exceptions. it will always match everything and needs to be ranked with 0 as
  // the JSONForms UnknownRenderer matches with -1 and every normal renderer matches with a value >=1
  return true;
}; // every renderer here is ranked with an integer one higher than the vue-vanilla renderers of JSONForms


var renderers = [{
  tester: rankWith(2, isBooleanControl),
  renderer: script$j
}, {
  tester: rankWith(3, isDateControl),
  renderer: script$h
}, {
  tester: rankWith(3, isDateTimeControl),
  renderer: script$g
}, {
  tester: rankWith(3, isEnumControl),
  renderer: script$f
}, {
  tester: rankWith(3, isOneOfEnumControl),
  renderer: script$e
}, {
  tester: rankWith(2, isIntegerControl),
  renderer: script$c
}, {
  tester: rankWith(3, and(isStringControl, isMultiLineControl)),
  renderer: script$1
}, {
  tester: rankWith(2, isNumberControl),
  renderer: script$a
}, {
  tester: rankWith(2, isStringControl),
  renderer: script$9
}, {
  tester: rankWith(3, isTimeControl),
  renderer: script$8
}, {
  tester: rankWith(0, alwaysMatchTester),
  renderer: script$7
}, {
  tester: rankWith(3, and(isLayout, uiTypeIs('Group'))),
  renderer: script$2
}, {
  tester: rankWith(3, and(isLayout, uiTypeIs('ExtendableGroup'))),
  renderer: script$2
}, {
  tester: rankWith(3, schemaTypeIs('array')),
  renderer: script$5
}].concat(_toConsumableArray(vanillaRenderers));
var script = defineComponent({
  name: 'PrintFormRendererComponent',
  components: {
    JsonForms: JsonForms
  },
  props: {
    formObject: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      renderers: Object.freeze(renderers),
      givenForm: this.formObject,
      data: JSON,
      formScheme: JSON,
      uiScheme: JSON
    };
  },
  provide: function provide() {
    return {
      styles: styles
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_json_forms = resolveComponent("json-forms");

  return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_json_forms, {
    data: _ctx.givenForm.answers,
    renderers: _ctx.renderers,
    schema: _ctx.givenForm.form_schema,
    uischema: _ctx.givenForm.form_ui_schema,
    readonly: true,
    validationMode: "NoValidation"
  }, null, 8, ["data", "renderers", "schema", "uischema"]), renderSlot(_ctx.$slots, "default")], 64);
}

script.render = render;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CustomBooleanControlRenderer: script$j,
  CustomControlWrapper: script$i,
  CustomControlWrapperCheckbox: script$k,
  CustomDateControlRenderer: script$h,
  CustomDateTimeControlRenderer: script$g,
  CustomEnumControlRenderer: script$f,
  CustomEnumOneOfControlRenderer: script$e,
  CustomGroupRenderer: script$d,
  CustomIntegerControlRenderer: script$c,
  CustomMultiStringControlRenderer: script$b,
  CustomNumberControlRenderer: script$a,
  CustomStringControlRenderer: script$9,
  CustomTimeControlRenderer: script$8,
  CustomUnknownRenderer: script$7,
  FormRenderComponent: script$3,
  PrintGroupRenderer: script$2,
  PrintMultiStringRenderer: script$1,
  PrintFormRenderComponent: script,
  CustomArrayListRenderer: script$5,
  ExtendableGroupRenderer: script$4
});

var install = function installVueJsJsonFormsBootstrapRenderer(app) {
  Object.entries(components).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        componentName = _ref2[0],
        component = _ref2[1];

    app.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export { script$5 as CustomArrayListRenderer, script$j as CustomBooleanControlRenderer, script$i as CustomControlWrapper, script$k as CustomControlWrapperCheckbox, script$h as CustomDateControlRenderer, script$g as CustomDateTimeControlRenderer, script$f as CustomEnumControlRenderer, script$e as CustomEnumOneOfControlRenderer, script$d as CustomGroupRenderer, script$c as CustomIntegerControlRenderer, script$b as CustomMultiStringControlRenderer, script$a as CustomNumberControlRenderer, script$9 as CustomStringControlRenderer, script$8 as CustomTimeControlRenderer, script$7 as CustomUnknownRenderer, script$4 as ExtendableGroupRenderer, script$3 as FormRenderComponent, script as PrintFormRenderComponent, script$2 as PrintGroupRenderer, script$1 as PrintMultiStringRenderer, install as default };
